export const BUSINESS_SIZES_OPTIONS = [
  { name: 'Sin ventas', value: 1 },
  { name: '0,01 UF - 200 UF', value: 2 },
  { name: '200,01 UF - 600 UF', value: 3 },
  { name: '600,01 UF - 2.400 UF', value: 4 },
  { name: '2.400,01 UF - 5.000 UF', value: 5 },
  { name: '5.000,01 UF - 10.000 UF', value: 6 },
  { name: '10.000,01 UF - 25.000 UF', value: 7 },
  { name: '25.000,01 UF - 50.000 UF', value: 8 },
  { name: '50.000,01 UF - 100.000 UF', value: 9 },
  { name: '100.000,01 UF - 200.000 UF', value: 10 },
  { name: '200.000,01 UF - 600.000 UF', value: 11 },
  { name: '600.000,01 UF - 1.000.000 UF', value: 12 },
  { name: 'Más de 1.000.000 UF', value: 13 }
]

export const BUSINESS_TYPES_OPTIONS = [
  { name: 'Persona Natural', value: 21 },
  { name: 'Persona Jurídica', value: 22 }
]

export const DNI_TEST = [
  '99.999.999-9',
  '88.888.888-8',
  '55.555.555-5',
  '44.444.444-4',
  '33.333.333-3',
  '33.333.334-1',
  '33.333.335-K',
  '33.333.336-8',
  '33.333.337-6',
  '33.333.338-4',
  '33.333.339-2',
  '33.333.340-6',
  '33.333.341-4',
  '33.333.342-2',
  '33.333.343-0',
  '33.333.344-9',
  '33.333.345-7',
  '33.333.346-5',
  '33.333.347-3',
  '33.333.348-1',
  '33.333.349-K',
  '33.333.350-3',
  '33.333.351-1',
  '33.333.352-K',
  '33.333.353-8'
]

export const COMMON_ERRORS = [
  'USER_NOT_FOUND_BY_DNI_ERROR',
  'USER_NOT_FOUND_ERROR',
  'SELLER_NOT_FOUND_ERROR',
  'SOMETHING_WENT_WRONG_ERROR'
]

export const FOREIGN_BUSINESS_SIZES_OPTIONS = [
  { name: 'RegisterWizardForeignBusinessInformation__sizeSelectOption__1', value: 1 },
  { name: '0,01 UF - 200 UF', value: 2 },
  { name: '200,01 UF - 600 UF', value: 3 },
  { name: '600,01 UF - 2.400 UF', value: 4 },
  { name: '2.400,01 UF - 5.000 UF', value: 5 },
  { name: '5.000,01 UF - 10.000 UF', value: 6 },
  { name: '10.000,01 UF - 25.000 UF', value: 7 },
  { name: '25.000,01 UF - 50.000 UF', value: 8 },
  { name: '50.000,01 UF - 100.000 UF', value: 9 },
  { name: '100.000,01 UF - 200.000 UF', value: 10 },
  { name: '200.000,01 UF - 600.000 UF', value: 11 },
  { name: '600.000,01 UF - 1.000.000 UF', value: 12 },
  { name: 'RegisterWizardForeignBusinessInformation__sizeSelectOption__13', value: 13 }
]

export const FOREIGN_BUSINESS_TYPES_OPTIONS = [
  { name: 'RegisterWizardForeignBusinessInformation__typeSelectOption__21', value: 21 },
  { name: 'RegisterWizardForeignBusinessInformation__typeSelectOption__22', value: 22 }
]

export const FOREIGN_GENDER_OPTIONS = [
  { name: 'RegisterWizardForeignPersonalInformation__genderSelectOption__1', value: 1 },
  { name: 'RegisterWizardForeignPersonalInformation__genderSelectOption__2', value: 2 }
]
export const AFFIDAVIT_SIGN_SOURCE = 'Inscripcion'

export const NATIONAL_GENDER_OPTIONS = [
  { name: 'Masculino', value: 1 },
  { name: 'Femenino', value: 2 }
]

export const CACHE_CONFIG = {
  LANDING: {
    key: 'landing',
    time: 2592000000 // 30 days
  },
  OVERLAY: {
    key: 'overlay'
  }
}
